import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import * as Scroll from 'react-scroll';
import { Theme } from '../../config/theme';

import { updateAppState } from '../../actions/applicationState';

import Button from '../Button';
import CompanyLogo from '../CompanyLogo';
import HeroHeading from '../HeroHeading';
import Paragraph from '../Paragraph';
import ScrollDownTrigger from '../ScrollDownTrigger';

let styles;
const ScrollLink = Scroll.Link;

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.scrollHandler = props.scrollHandler.bind(this);

    this.unauthenticatedLinks = [
      (!Theme.isMobile ? <ScrollLink
        to="homepage-inspiration-1"
        spy
        smooth
        duration={1200}
        className={css(styles.login_link)}
        key="unauthenticated-link-1"
      >
        <div>How It Works</div>
      </ScrollLink> : null),

      (!Theme.isMobile ? <Link
        to="/story"
        className={css(styles.login_link)}
        key="unauthenticated-link-2"
      >
        <div>Our Story</div>
      </Link> : null),

      (<div
        className={css(styles.login_link)}
        onClick={this.openLoginHandler}
        role="link"
        tabIndex={0}
        key="unauthenticated-link-3"
      >
        <div>Login</div>
      </div>),
    ];
  }

  loginModalOpenHandler() {
    this.props.dispatch(updateAppState({
      login_modal_open: true,
    }));
  }

  render() {
    return (
      <div className={css(styles.container)}>
        {!Theme.isMobile ?
          <video
            className={css(styles.video)}
            autoPlay
            loop
            muted
            style={{ opacity: 0 }}
            onCanPlay={(e) => { e.target.style.opacity = 1; }}
          >
            <source src={'/media/background.mp4'} type="video/mp4" />
          </video>
        : null}
        <div className={css(styles.header_container)}>
          <div className={css(styles.header)}>
            <CompanyLogo styles={styles.company_logo} />
            <div className={css(styles.buttons)}>
              {!this.props.user.isAuthenticated ? this.unauthenticatedLinks : false}
              {/* eslint-disable */}
              {!Theme.isMobile ?
                this.props.user.isAuthenticated ? (
                  <Link to="/find">
                    <Button title="Go to Dashboard" />
                  </Link>
                ) : (
                  <Link to="/join">
                    <Button title="Join the collective" />
                  </Link>
                )
              :
                this.props.user.isAuthenticated ? (
                  <Link to="/find" className={css(styles.join_link)}>
                    <div>Dashboard</div>
                  </Link>
                ) : (
                  <Link to="/join" className={css(styles.join_link)}>
                    <div>Join</div>
                  </Link>
                )
              }
              {/* eslint-enable */}
            </div>
          </div>
        </div>
        <div className={css(styles.hero_text_container)}>
          <HeroHeading>
            <h1>Be a dog’s best friend</h1>
          </HeroHeading>
          <Paragraph styles={styles.paragraph}>
            You can{'\''}t always be around your dog. Good thing is, heaps of people would love to have a dog around, just sometimes. Our mission is to make that introduction, with The Dog Share Collective.
          </Paragraph>
          {Theme.isMobile ? (
            <Link to="/join" className={css(styles.join_container)}>
              <Button styles={styles.btn} title="Join the collective" />
            </Link>
          ) : null}
        </div>
        {!Theme.isMobile ? <ScrollDownTrigger handler={this.scrollHandler} /> : null}
      </div>
    );
  }
}

Home.propTypes = {
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  scrollHandler: PropTypes.func.isRequired,
};

styles = StyleSheet.create({
  container: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100vw',
    height: '100vh',
    // backgroundImage: 'url(/images/background.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: '#aaaaaa',
    overflow: 'hidden',

    [Theme.mobile_query]: {
      // height: 'calc(100vh - 40px)',
      // maxHeight: 627,
      height: 'auto',
      backgroundPosition: 'top center',
      backgroundImage: 'url(/images/hero_mob.jpg)',
      backgroundColor: '#001227',
    },
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    minWidth: '100%',
    minWeight: '100%',
    maxWidth: '100%',
    width: 'auto',
    height: '100%',
    zIndex: -100,
    transition: 'opacity 1s',
    objectFit: 'cover',
    // TODO IE/EDGE Object Fit Fallback

    [Theme.mobile_query]: {
      display: 'none',
      height: 0,
      width: 0,
      pointerEvents: 'none',
    },
  },
  join_container: {
    width: '100%',
  },
  btn: {
    width: 'calc(100% - 40px)',
    margin: '40px 20px 0',
  },
  header_container: {
    position: 'relative',
    display: 'block',
    margin: '0 auto',
    // paddingTop: 20,
    height: Theme.navigation.height,
    width: Theme.container_width,
    maxWidth: '100vw',

    [Theme.mobile_query]: {
      height: 110,
    },
  },
  header: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row',
    height: Theme.navigation.height,
  },
  company_logo: {
    position: 'absolute',
    top: 10,
    left: 0,
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',

    [Theme.mobile_query]: {
      alignItems: 'flex-start',
      marginTop: 15,
      marginRight: 15,
    },
  },
  login_link: {
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    letterSpacing: 1,
    color: Theme.white,
    transition: 'all 160ms ease-in-out',
    marginRight: 40,
    ':hover': {
      color: Theme.primary,
      textShadow: 'none',
    },
    [Theme.mobile_query]: {
      marginRight: 0,
      lineHeight: '30px',
    },
    textShadow: '0px 0px 2px #000',
  },
  join_link: {
    cursor: 'pointer',
    textTransform: 'uppercase',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    fontSize: Theme.font_size_secondary,
    lineHeight: '30px',
    letterSpacing: 1,
    color: Theme.primary,
    transition: 'all 160ms ease-in-out',
    marginLeft: 20,
    paddingLeft: 20,
    ':hover': {
      color: Theme.primary,
    },
    ':not(:first-child)': {
      borderLeft: '1px solid #fff',
    },
  },
  hero_text_container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    [Theme.mobile_query]: {
      paddingBottom: 51,
      justifyContent: 'flex-end',
    },
  },
  paragraph: {
    marginTop: 20,
    lineHeight: '30px',
    width: 630,
    textAlign: 'center',
    color: Theme.white,

    [Theme.mobile_query]: {
      width: 'auto',
      padding: '0 30px',
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/HomepageHero/index.js